<template>
  <div class="floating-menu">
    <v-menu>
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="var(--main-color)" v-bind="attrs" v-on="on" fab>
          <img
            src="@/assets/icones/estrelas.svg"
            alt="Menu"
            width="24"
            height="24"
          />
        </v-btn>
      </template>
      <v-card class="floating-menu__card" elevation="6">
        <div class="floating-menu__header">
          <div class="floating-menu__greeting">
            <h1 class="floating-menu__title">Olá, {{ usuario.nome }}</h1>
            <span class="floating-menu__subtitle"
              >O que deseja fazer hoje?</span
            >
          </div>
          <v-btn
            icon
            pill
            size="small"
            class="floating-menu__close-btn"
            @click="isMenuOpen = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>

        <v-list class="floating-menu__list" nav>
          <v-list-item
            v-for="(item, index) in filteredItems"
            :key="index"
            :value="index"
            class="floating-menu__item"
            :to="withRolePrefix(item.href)"
          >
            <div class="floating-menu__item-content">
              <div
                class="floating-menu__item-icon"
                :class="{
                  'floating-menu__item-icon--highlighted':
                    index < filteredItems.length - 1,
                }"
              >
                <component
                  :is="item.icon"
                  alt="Menu"
                  width="30"
                  height="30"
                  color="var(--main-color)"
                />
              </div>
              <div class="floating-menu__item-text">
                <p class="floating-menu__item-title">{{ item.title }}</p>
                <p class="floating-menu__item-description">
                  {{ item.description }}
                </p>
              </div>
            </div>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
import ChatEstrelaIcon from "@/components/icons/ChatEstrelaIcon.vue";
import EstrelaGrandeIcon from "@/components/icons/EstrelaGrandeIcon.vue";
import LapisEstrelaIcon from "@/components/icons/LapisEstrelaIcon.vue";
import LivroEstrelaIcon from "@/components/icons/LivroEstrelaIcon.vue";
import TelevisaoIcon from "@/components/icons/TelevisaoIcon.vue";
export default {
  name: "FloatingMenu",
  props: {
    usuario: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isMenuOpen: false,
      items: [
        {
          title: "Análises qualitativas",
          description: "Relatórios inteligentes sobre os alunos.",
          icon: TelevisaoIcon,
          slug: "analises-qualitativas",
        },
        {
          title: "Planos de aula",
          description: "Planos rápidos e personalizados.",
          icon: LivroEstrelaIcon,
          slug: "planos-de-aula",
          href: "/professor/assistente-ia/planos",
        },
        {
          title: "Atividades de reforço",
          description: "Exercícios adaptados automaticamente.",
          icon: LapisEstrelaIcon,
          slug: "atividades-de-reforco",
        },
        {
          title: "Chat",
          description: "Suporte inteligente para você.",
          icon: ChatEstrelaIcon,
          slug: "chat",
          href: "/professor/assistente-ia/chat",
        },
        {
          title: "Meus materiais",
          description: "Acesse os materiais que você salvou.",
          icon: EstrelaGrandeIcon,
          slug: "meus-materiais",
          href: "/professor/assistente-ia/materiais",
        },
      ],
    };
  },
  computed: {
    filteredItems() {
      const userPrivilege = this.usuario.id_privilegio;
      if (userPrivilege === 3) {
        return this.items.filter((item) => item.slug === "chat");
      }
      if (userPrivilege === 2) {
        return this.items.filter(
          (item) =>
            item.slug === "planos-de-aula" || item.slug === "meus-materiais"
        );
      }
      return [];
    },
  },
  methods: {
    withRolePrefix(href) {
      if (!href) return undefined;
      const parts = href.split("/").filter(Boolean);
      if (parts.length === 0) return undefined;
      parts[0] = this.usuario.slug_privilegio;
      return "/" + parts.join("/");
    },
  },
};
</script>

<style scoped>
/* Block: floating-menu */
.floating-menu {
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  z-index: 999;
}

/* Element: floating-menu__trigger */
.floating-menu__trigger {
  border-radius: 50% !important;
}

/* Element: floating-menu__card */
.floating-menu__card {
  padding: 1.25rem !important;
  border-radius: 0.5rem !important;
}

/* Element: floating-menu__header */
.floating-menu__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

/* Element: floating-menu__greeting */
.floating-menu__greeting {
  margin-right: 3rem;
}

/* Element: floating-menu__title */
.floating-menu__title {
  font-size: 1rem;
  font-weight: bold;
  margin: 0;
}

/* Element: floating-menu__subtitle */
.floating-menu__subtitle {
  font-size: 0.875rem;
}

/* Element: floating-menu__list */
.floating-menu__list {
  margin-top: 1.25rem;
}

/* Element: floating-menu__item */
.floating-menu__item {
  margin-bottom: 0.75rem !important;
  border: 1px solid #e5e7eb !important;
  border-style: solid !important;
  padding: 0.75rem !important;
}

/* Element: floating-menu__item-content */
.floating-menu__item-content {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}

/* Element: floating-menu__item-icon */
.floating-menu__item-icon {
  height: 3rem;
  width: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.25rem;
}

/* Modifier: floating-menu__item-icon--highlighted */
.floating-menu__item-icon--highlighted {
  background-color: var(--tertiary-color);
}

/* Element: floating-menu__item-title */
.floating-menu__item-title {
  font-size: 0.875rem;
  font-weight: bold;
  margin: 0;
}

/* Element: floating-menu__item-description */
.floating-menu__item-description {
  font-size: 0.875rem;
  margin: 0;
}
</style>